import * as React from "react";
const SvgSortingNewZa = props => <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 14 16" {...props}><path d="M0 12h6v2H0zM0 7h10v2H0zM0 2h14v2H0z" /></svg>;
export default SvgSortingNewZa;